import styled from "styled-components";
import { ReactComponent as BagSvg } from "../../assets/shopping-bag.svg";

export const BagIcon = styled(BagSvg)`
  width: 24px;
  height: 24px;
`;

export const CartIconContainer = styled.button`
  width: 45px;
  height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background: none;
`;

export const ItemCount = styled.span`
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  bottom: 12px;
`;
